var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4893 18.4348C12.3905 19.535 13.3467 20.4021 14.4506 20.3636L14.7573 20.3529C15.8611 20.3143 16.6604 19.3641 16.9636 18.302C17.2885 17.1635 18.0007 16.2605 19.2035 15.4788C21.2832 14.1441 22.6104 12.4262 22.5172 9.75742C22.3784 5.78257 19.0949 3.57764 14.5863 3.73508C11.1306 3.85576 8.26244 5.474 7.45832 8.67221C7.18469 9.76052 8.15675 10.6682 9.27825 10.6291L9.94097 10.6059C11.0163 10.5684 11.7864 9.59188 12.4287 8.72867C12.9576 8.01785 13.8011 7.62849 14.6984 7.59716C16.2316 7.54362 17.5051 8.52249 17.5603 10.1011C17.6122 11.5888 16.5678 12.6145 15.2019 13.5491C13.3404 14.8165 12.6655 16.4744 12.4893 18.4348ZM14.9429 27.6236C16.3966 27.5728 17.6147 26.3136 17.5734 24.8028C17.51 23.3154 16.207 22.1443 14.7534 22.195C13.2543 22.2474 12.0588 23.5058 12.1221 24.9931C12.1635 26.504 13.4438 27.6759 14.9429 27.6236Z",
    fill: "#854CC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionSmall);
export default __webpack_public_path__ + "static/media/questionSmall.7f7f4a6dff7e415521b60ab219856c30.svg";
export { ForwardRef as ReactComponent };